import { Grid } from '@mui/material';
import styled from 'styled-components';

export const Form = styled(Grid)`
  padding: 2rem 1rem;
`;
